import axiosInstance from './axiosInstance';

export const getDocumentTypes = (params) => axiosInstance.get('/api/v1/document-types', { params });
export const createDocumentType = (data) => axiosInstance.post('/api/v1/document-types', data);
export const updateDocumentType = (id, data) => axiosInstance.patch(`/api/v1/document-types/${id}`, data);
export const deleteDocumentType = (id) => axiosInstance.delete(`/api/v1/document-types/${id}`);
